module.exports = __webpack_public_path__ + "static/media/sidebar-2.51bd37fe.jpg";